import React from 'react';
import { Group } from '../../types';
import './AddUserModal.scss';

interface AddUserModalProps {
  isOpen: boolean;
  userName: string;
  selectedGroupId: string;
  groups: Group[];
  onUserNameChange: (name: string) => void;
  onGroupChange: (groupId: string) => void;
  onConfirm: () => void;
  onClose: () => void;
}

const AddUserModal: React.FC<AddUserModalProps> = ({
  isOpen,
  userName,
  selectedGroupId,
  groups,
  onUserNameChange,
  onGroupChange,
  onConfirm,
  onClose,
}) => {
  if (!isOpen) return null;

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onConfirm();
    }
  };

  // Show all real groups (not standalone users) in the dropdown
  const realGroups = groups.filter(g => g.isRealGroup === true);

  return (
    <div className="tip-modal-overlay" onClick={onClose}>
      <div className="tip-modal" onClick={e => e.stopPropagation()}>
        <h3 className="modal-title">Agregar Usuario</h3>
        <input
          type="text"
          placeholder="Nombre del usuario"
          value={userName}
          onChange={e => onUserNameChange(e.target.value)}
          onKeyPress={handleKeyPress}
          className="modal-input"
          autoFocus
        />
        <div className="modal-group">
          <label className="modal-label">Asignar a grupo (opcional):</label>
          <select
            value={selectedGroupId}
            onChange={e => onGroupChange(e.target.value)}
            className="modal-select"
          >
            <option value="">Sin grupo (individual)</option>
            {realGroups.map(g => (
              <option key={g.id} value={g.id}>
                {g.name}
              </option>
            ))}
          </select>
        </div>
        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onClose}>
            Cancelar
          </button>
           <button className="btn btn-primary" onClick={onConfirm}>
            Agregar
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddUserModal;
